import { render, staticRenderFns } from "./WebsiteBanner.vue?vue&type=template&id=c71923bc&scoped=true&"
import script from "./WebsiteBanner.vue?vue&type=script&lang=js&"
export * from "./WebsiteBanner.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteBanner.vue?vue&type=style&index=0&id=c71923bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71923bc",
  null
  
)

export default component.exports